var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 325.001,
    viewBox: "0 0 375 325.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MASK",
    width: 375,
    height: 150,
    transform: "translate(0 446)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17",
    "data-name": "\\u9577\\u65B9\\u5F62 17",
    width: 172,
    height: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_19",
    "data-name": "\\u9577\\u65B9\\u5F62 19",
    width: 115,
    height: 82,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_8",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8",
    transform: "translate(0 -486.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_213",
    "data-name": "\\u30D1\\u30B9 213",
    d: "M0-6813v-324.878c.9-.082,1.824-.124,2.735-.124a32.059,32.059,0,0,1,11.916,2.336,30.119,30.119,0,0,1,9.906,6.483,44.637,44.637,0,0,0,11.558,8.358,34.718,34.718,0,0,0,6.564,2.483,26.594,26.594,0,0,0,6.721.9,21.271,21.271,0,0,0,7.73-1.412,21.777,21.777,0,0,0,7.141-4.6c4.229-4.02,8.991-6.059,14.154-6.059a25.754,25.754,0,0,1,13.29,4.154,54.17,54.17,0,0,1,12.93,11.478c6.367,7.529,11.727,13.613,17.885,17.7,6.478,4.3,13.541,6.22,22.9,6.22a131.917,131.917,0,0,1,24.437,1.842c6.567,1.261,11.743,3.226,15.823,6a47.215,47.215,0,0,1,4.742,3.919l.025.02c4.45,4,9.494,8.534,16.982,8.534a22.267,22.267,0,0,0,6.861-1.168,38.832,38.832,0,0,0,8.226-3.948c5.15-3.187,9.369-6.03,13.092-8.538l.016-.011.032-.021.054-.036.016-.012.011-.009.007-.005c5.575-3.754,9.976-6.721,14.4-8.736a33.718,33.718,0,0,1,14.664-3.1c7.639,0,13.475-1.29,18.924-4.187a45.176,45.176,0,0,0,7.947-5.5,105.013,105.013,0,0,0,8.319-8.015,33.659,33.659,0,0,1,5.365-4.575,34.768,34.768,0,0,1,6.118-3.354,34.666,34.666,0,0,1,13.418-2.764,30.626,30.626,0,0,1,10.77,1.908,28.108,28.108,0,0,1,9.5,5.913,30.085,30.085,0,0,0,10.29,6,116.089,116.089,0,0,0,12.5,3.6h.011l.018.005.009.005c2.377.588,4.7,1.168,6.986,1.811V-6813Z",
    transform: "translate(0 7625)",
    fill: "#e9fdf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "illust",
    transform: "translate(0 134)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illust01",
    transform: "translate(102 488)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_216",
    "data-name": "\\u30D1\\u30B9 216",
    d: "M67.144,24.781A12.024,12.024,0,1,0,55.119,36.8,12.021,12.021,0,0,0,67.144,24.781",
    transform: "translate(7.541 2.225)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_10",
    "data-name": "\\u6955\\u5186\\u5F62 10",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(50.638 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_217",
    "data-name": "\\u30D1\\u30B9 217",
    d: "M67.144,24.781A12.024,12.024,0,1,0,55.119,36.8,12.021,12.021,0,0,0,67.144,24.781",
    transform: "translate(7.541 2.225)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_11",
    "data-name": "\\u6955\\u5186\\u5F62 11",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(50.638 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_218",
    "data-name": "\\u30D1\\u30B9 218",
    d: "M106.883,24.781A12.024,12.024,0,1,0,94.86,36.8a12.02,12.02,0,0,0,12.024-12.017",
    transform: "translate(14.495 2.225)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_12",
    "data-name": "\\u6955\\u5186\\u5F62 12",
    cx: 12.024,
    cy: 12.017,
    rx: 12.024,
    ry: 12.017,
    transform: "translate(97.331 14.989)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_219",
    "data-name": "\\u30D1\\u30B9 219",
    d: "M3.854,84.229H168.047a3.569,3.569,0,1,0,0-7.138H3.854a3.569,3.569,0,1,0,0,7.138",
    transform: "translate(0.05 13.439)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_220",
    "data-name": "\\u30D1\\u30B9 220",
    d: "M3.854,84.229H168.047a3.569,3.569,0,1,0,0-7.138H3.854a3.569,3.569,0,1,0,0,7.138Z",
    transform: "translate(0.05 13.439)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_221",
    "data-name": "\\u30D1\\u30B9 221",
    d: "M100.865,22.15c-1.529.073-3.641-1.432-4.741-2.642a.937.937,0,0,0-1.437,1.2l1.29,1.679-6.149.193a.87.87,0,0,0-.842.909l.007.169a.872.872,0,0,0,.839.831l5.423.19-6.14.478a.87.87,0,0,0-.8.981v.018a.872.872,0,0,0,.862.757l6.152.013-5.815.618a.869.869,0,0,0-.758,1.055l0,.012a.869.869,0,0,0,.875.68l5.93-.178-3.9.747a.871.871,0,0,0,.277,1.718c1.947-.256,7.21-.929,9.628-1.058Z",
    transform: "translate(15.453 3.347)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_222",
    "data-name": "\\u30D1\\u30B9 222",
    d: "M100.865,22.15c-1.529.073-3.641-1.432-4.741-2.642a.937.937,0,0,0-1.437,1.2l1.29,1.679-6.149.193a.87.87,0,0,0-.842.909l.007.169a.872.872,0,0,0,.839.831l5.423.19-6.14.478a.87.87,0,0,0-.8.981v.018a.872.872,0,0,0,.862.757l6.152.013-5.815.618a.869.869,0,0,0-.758,1.055l0,.012a.869.869,0,0,0,.875.68l5.93-.178-3.9.747a.871.871,0,0,0,.277,1.718c1.947-.256,7.21-.929,9.628-1.058Z",
    transform: "translate(15.453 3.347)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_223",
    "data-name": "\\u30D1\\u30B9 223",
    d: "M122.571,14.261a22.605,22.605,0,0,1-8.386,6.592C109.078,23.211,99,23.011,99,23.011l.709,8.366c15.238-.124,24.31-3.081,28.849-9.195",
    transform: "translate(17.323 2.486)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_224",
    "data-name": "\\u30D1\\u30B9 224",
    d: "M122.571,14.261a22.605,22.605,0,0,1-8.386,6.592C109.078,23.211,99,23.011,99,23.011l.709,8.366c15.238-.124,24.31-3.081,28.849-9.195",
    transform: "translate(17.323 2.486)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_225",
    "data-name": "\\u30D1\\u30B9 225",
    d: "M106.316,45.351V24.893a13.05,13.05,0,0,1,13.015-13.008h.295a12.241,12.241,0,0,1,11.99,10.363,9.506,9.506,0,0,0,2.969,5.605,8.735,8.735,0,0,1,3.667,6.44c.392,2.218,1.229,4.054,4.389,4.667a3.228,3.228,0,0,1-.649,6.391Z",
    transform: "translate(18.604 2.072)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_226",
    "data-name": "\\u30D1\\u30B9 226",
    d: "M106.316,45.351V24.893a13.05,13.05,0,0,1,13.015-13.008h.295a12.241,12.241,0,0,1,11.99,10.363,9.506,9.506,0,0,0,2.969,5.605,8.735,8.735,0,0,1,3.667,6.44c.392,2.218,1.229,4.054,4.389,4.667a3.228,3.228,0,0,1-.649,6.391Z",
    transform: "translate(18.604 2.072)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_227",
    "data-name": "\\u30D1\\u30B9 227",
    d: "M113.415,9.951v4.743c0,3.141,7.33,2.963,7.33-.393V9.951Z",
    transform: "translate(19.846 1.734)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_228",
    "data-name": "\\u30D1\\u30B9 228",
    d: "M113.415,9.951v4.743c0,3.141,7.33,2.963,7.33-.393V9.951Z",
    transform: "translate(19.846 1.734)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_229",
    "data-name": "\\u30D1\\u30B9 229",
    d: "M119.993,15a7.633,7.633,0,1,0-2.587.528",
    transform: "translate(19.172 0.049)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_230",
    "data-name": "\\u30D1\\u30B9 230",
    d: "M119.993,15a7.633,7.633,0,1,0-2.587.528",
    transform: "translate(19.172 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_8",
    "data-name": "\\u7DDA 8",
    x1: 1.406,
    y2: 0.04,
    transform: "translate(130.662 8.491)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_231",
    "data-name": "\\u30D1\\u30B9 231",
    d: "M110.014,5.9h0a1.627,1.627,0,1,0,1.673,1.579A1.632,1.632,0,0,0,110.014,5.9Z",
    transform: "translate(18.974 1.029)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_232",
    "data-name": "\\u30D1\\u30B9 232",
    d: "M113.98,5.791h0a1.627,1.627,0,1,0,1.673,1.579A1.632,1.632,0,0,0,113.98,5.791Z",
    transform: "translate(19.668 1.009)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_233",
    "data-name": "\\u30D1\\u30B9 233",
    d: "M112.614,9.511l-1.2.034a.5.5,0,0,1-.5-.594l.338-1.684.542-.015",
    transform: "translate(19.406 1.264)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_234",
    "data-name": "\\u30D1\\u30B9 234",
    d: "M112.614,9.511l-1.2.034a.5.5,0,0,1-.5-.594l.338-1.684.542-.015",
    transform: "translate(19.406 1.264)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_235",
    "data-name": "\\u30D1\\u30B9 235",
    d: "M117.33,13.316a8.837,8.837,0,0,1-3.916-.058v-.494a8.071,8.071,0,0,0,3.916.552",
    transform: "translate(19.846 2.225)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_236",
    "data-name": "\\u30D1\\u30B9 236",
    d: "M117.33,13.316a8.837,8.837,0,0,1-3.916-.058v-.494A8.071,8.071,0,0,0,117.33,13.316Z",
    transform: "translate(19.846 2.225)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_237",
    "data-name": "\\u30D1\\u30B9 237",
    d: "M120.927,40.383c.437,4-1.7,7.054-3.565,9.349V45.057Z",
    transform: "translate(20.536 7.04)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_238",
    "data-name": "\\u30D1\\u30B9 238",
    d: "M120.927,40.383c.437,4-1.7,7.054-3.565,9.349V45.057Z",
    transform: "translate(20.536 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_239",
    "data-name": "\\u30D1\\u30B9 239",
    d: "M93.778,78.442h0a2.836,2.836,0,0,1,2.838-2.836h4.008v-2.34h12.159v8.012H96.616a2.836,2.836,0,0,1-2.838-2.836",
    transform: "translate(16.41 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_240",
    "data-name": "\\u30D1\\u30B9 240",
    d: "M93.778,78.442h0a2.836,2.836,0,0,1,2.838-2.836h4.008v-2.34h12.159v8.012H96.616A2.836,2.836,0,0,1,93.778,78.442Z",
    transform: "translate(16.41 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_241",
    "data-name": "\\u30D1\\u30B9 241",
    d: "M124.035,40.383H107.491l-5.8,8.806A12.645,12.645,0,0,0,99.6,56.146V79h12.159V55.414c8.708-6.958,12.273-11.38,12.273-15.031",
    transform: "translate(17.429 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_242",
    "data-name": "\\u30D1\\u30B9 242",
    d: "M124.035,40.383H107.491l-5.8,8.806A12.645,12.645,0,0,0,99.6,56.146V79h12.159V55.414C120.47,48.457,124.035,44.034,124.035,40.383Z",
    transform: "translate(17.429 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_243",
    "data-name": "\\u30D1\\u30B9 243",
    d: "M99.6,73.267h12.159V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(17.429 12.772)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_244",
    "data-name": "\\u30D1\\u30B9 244",
    d: "M99.6,73.267h12.159V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(17.429 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_245",
    "data-name": "\\u30D1\\u30B9 245",
    d: "M50.539,78.442h0A2.836,2.836,0,0,0,47.7,75.606H43.694v-2.34H31.535v8.012H47.7a2.836,2.836,0,0,0,2.838-2.836",
    transform: "translate(5.518 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_246",
    "data-name": "\\u30D1\\u30B9 246",
    d: "M50.539,78.442h0A2.836,2.836,0,0,0,47.7,75.606H43.694v-2.34H31.535v8.012H47.7A2.836,2.836,0,0,0,50.539,78.442Z",
    transform: "translate(5.518 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_247",
    "data-name": "\\u30D1\\u30B9 247",
    d: "M32.978,78.442h0a2.836,2.836,0,0,0-2.838-2.836H26.133v-2.34H13.974v8.012H30.141a2.836,2.836,0,0,0,2.838-2.836",
    transform: "translate(2.445 12.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_248",
    "data-name": "\\u30D1\\u30B9 248",
    d: "M32.978,78.442h0a2.836,2.836,0,0,0-2.838-2.836H26.133v-2.34H13.974v8.012H30.141A2.836,2.836,0,0,0,32.978,78.442Z",
    transform: "translate(2.445 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_249",
    "data-name": "\\u30D1\\u30B9 249",
    d: "M21.09,40.383H37.634l5.8,8.806a12.645,12.645,0,0,1,2.086,6.957V79H33.363V55.414C24.655,48.457,21.09,44.034,21.09,40.383",
    transform: "translate(3.69 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_250",
    "data-name": "\\u30D1\\u30B9 250",
    d: "M21.09,40.383H37.634l5.8,8.806a12.645,12.645,0,0,1,2.086,6.957V79H33.363V55.414C24.655,48.457,21.09,44.034,21.09,40.383Z",
    transform: "translate(3.69 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_251",
    "data-name": "\\u30D1\\u30B9 251",
    d: "M31.535,73.267H43.694V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(5.518 12.772)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_252",
    "data-name": "\\u30D1\\u30B9 252",
    d: "M31.535,73.267H43.694V75.71a1.35,1.35,0,0,0-1.215-1.343Z",
    transform: "translate(5.518 12.772)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_253",
    "data-name": "\\u30D1\\u30B9 253",
    d: "M131.47,82.093h0a3.22,3.22,0,0,1-.283-4.558l2.395-2.7-1.752-1.552,8.067-9.092L146.49,70,136.013,81.811a3.226,3.226,0,0,1-4.542.282",
    transform: "translate(22.813 11.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_254",
    "data-name": "\\u30D1\\u30B9 254",
    d: "M131.47,82.093h0a3.22,3.22,0,0,1-.283-4.558l2.395-2.7-1.752-1.552,8.067-9.092L146.49,70,136.013,81.811A3.226,3.226,0,0,1,131.47,82.093Z",
    transform: "translate(22.813 11.19)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_255",
    "data-name": "\\u30D1\\u30B9 255",
    d: "M134.106,77.435,120.089,63.146a9.533,9.533,0,0,1-2.727-6.674V40.383h12.16V56.361l12.651,11.983Z",
    transform: "translate(20.536 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_256",
    "data-name": "\\u30D1\\u30B9 256",
    d: "M134.106,77.435,120.089,63.146a9.533,9.533,0,0,1-2.727-6.674V40.383h12.16V56.361l12.651,11.983Z",
    transform: "translate(20.536 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_257",
    "data-name": "\\u30D1\\u30B9 257",
    d: "M116.719.286a7.6,7.6,0,0,0-5.7,2.825c3.2,2.68,8.192,3.586,8.192,3.586-.867,3.469-.466,6.218,2.572,7.094A7.62,7.62,0,0,0,116.719.286",
    transform: "translate(19.426 0.049)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_258",
    "data-name": "\\u30D1\\u30B9 258",
    d: "M116.719.286a7.6,7.6,0,0,0-5.7,2.825c3.2,2.68,8.192,3.586,8.192,3.586-.867,3.469-.466,6.218,2.572,7.094A7.62,7.62,0,0,0,116.719.286Z",
    transform: "translate(19.426 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_259",
    "data-name": "\\u30D1\\u30B9 259",
    d: "M26.308,79V40.383H12.973L14.149,79Z",
    transform: "translate(2.27 7.04)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_260",
    "data-name": "\\u30D1\\u30B9 260",
    d: "M26.308,79V40.383H12.973L14.149,79Z",
    transform: "translate(2.27 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_261",
    "data-name": "\\u30D1\\u30B9 261",
    d: "M49.436,22.747c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L54.277,23.46l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L60.2,29.224a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125A.87.87,0,0,1,57.39,33c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(8.384 3.545)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_262",
    "data-name": "\\u30D1\\u30B9 262",
    d: "M49.436,22.747c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L54.277,23.46l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L60.2,29.224a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125A.87.87,0,0,1,57.39,33c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(8.384 3.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_263",
    "data-name": "\\u30D1\\u30B9 263",
    d: "M32.172,14.482a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C36.9,30.409,28.162,26.579,24.243,20.051",
    transform: "translate(4.242 2.524)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_264",
    "data-name": "\\u30D1\\u30B9 264",
    d: "M32.172,14.482a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C36.9,30.409,28.162,26.579,24.243,20.051",
    transform: "translate(4.242 2.524)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_265",
    "data-name": "\\u30D1\\u30B9 265",
    d: "M12.973,25.349v24.04h9.356a36.6,36.6,0,0,0,16.726-4.044v-20A13.243,13.243,0,0,0,26.014,11.915,13.242,13.242,0,0,0,12.973,25.349",
    transform: "translate(2.27 2.077)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_266",
    "data-name": "\\u30D1\\u30B9 266",
    d: "M12.973,25.349v24.04h9.356a36.6,36.6,0,0,0,16.726-4.044v-20A13.243,13.243,0,0,0,26.014,11.915,13.242,13.242,0,0,0,12.973,25.349Z",
    transform: "translate(2.27 2.077)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_267",
    "data-name": "\\u30D1\\u30B9 267",
    d: "M28.506,9.951v4.743c0,3.141-7.33,2.963-7.33-.393V9.951Z",
    transform: "translate(3.705 1.734)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_268",
    "data-name": "\\u30D1\\u30B9 268",
    d: "M28.506,9.951v4.743c0,3.141-7.33,2.963-7.33-.393V9.951Z",
    transform: "translate(3.705 1.734)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_269",
    "data-name": "\\u30D1\\u30B9 269",
    d: "M23.107,15a7.633,7.633,0,1,1,2.587.528",
    transform: "translate(3.199 0.049)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_270",
    "data-name": "\\u30D1\\u30B9 270",
    d: "M23.107,15a7.633,7.633,0,1,1,2.587.528",
    transform: "translate(3.199 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_9",
    "data-name": "\\u7DDA 9",
    x2: 1.406,
    y2: 0.04,
    transform: "translate(33.403 8.491)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_271",
    "data-name": "\\u30D1\\u30B9 271",
    d: "M31.3,5.9h0a1.627,1.627,0,1,1-1.673,1.579A1.632,1.632,0,0,1,31.3,5.9Z",
    transform: "translate(5.184 1.029)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_272",
    "data-name": "\\u30D1\\u30B9 272",
    d: "M27.332,5.791h0a1.627,1.627,0,1,1-1.673,1.579A1.632,1.632,0,0,1,27.332,5.791Z",
    transform: "translate(4.49 1.009)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_273",
    "data-name": "\\u30D1\\u30B9 273",
    d: "M28.47,9.511l1.2.034a.5.5,0,0,0,.5-.594l-.338-1.684-.542-.015",
    transform: "translate(4.982 1.264)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_274",
    "data-name": "\\u30D1\\u30B9 274",
    d: "M28.47,9.511l1.2.034a.5.5,0,0,0,.5-.594l-.338-1.684-.542-.015",
    transform: "translate(4.982 1.264)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_275",
    "data-name": "\\u30D1\\u30B9 275",
    d: "M24.082,13.316A8.837,8.837,0,0,0,28,13.258v-.494a8.071,8.071,0,0,1-3.916.552",
    transform: "translate(4.214 2.225)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_276",
    "data-name": "\\u30D1\\u30B9 276",
    d: "M24.082,13.316A8.837,8.837,0,0,0,28,13.258v-.494A8.071,8.071,0,0,1,24.082,13.316Z",
    transform: "translate(4.214 2.225)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_277",
    "data-name": "\\u30D1\\u30B9 277",
    d: "M19.538,7.689a7.77,7.77,0,0,1,7.841-7.4,7.6,7.6,0,0,1,5.7,2.825c-3.2,2.68-8.192,3.588-8.192,3.588.867,3.469.979,6.863-2.06,7.739-5.692,2.259-9.479,7.581-9.479,12.94-4.391-6.227-1.2-10.019.583-11.693s1.69-3.934,3.2-5.033,2.262-1.258,2.4-2.963",
    transform: "translate(1.949 0.049)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_278",
    "data-name": "\\u30D1\\u30B9 278",
    d: "M19.538,7.689a7.77,7.77,0,0,1,7.841-7.4,7.6,7.6,0,0,1,5.7,2.825c-3.2,2.68-8.192,3.588-8.192,3.588.867,3.469.979,6.863-2.06,7.739-5.692,2.259-9.479,7.581-9.479,12.94-4.391-6.227-1.2-10.019.583-11.693s1.69-3.934,3.2-5.033S19.4,9.395,19.538,7.689Z",
    transform: "translate(1.949 0.049)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_279",
    "data-name": "\\u30D1\\u30B9 279",
    d: "M59.542,22.455C56.851,24.71,54.8,21.284,53.1,20.971s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439c6,0,7.211,4.576,4.52,6.831",
    transform: "translate(8.15 2.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_280",
    "data-name": "\\u30D1\\u30B9 280",
    d: "M59.542,22.455C56.851,24.71,54.8,21.284,53.1,20.971s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439C61.022,15.624,62.232,20.2,59.542,22.455Z",
    transform: "translate(8.15 2.723)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_281",
    "data-name": "\\u30D1\\u30B9 281",
    d: "M99.133,22.455c-2.691,2.255-4.746-1.171-6.445-1.484s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439c6,0,7.211,4.576,4.52,6.831",
    transform: "translate(15.078 2.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_282",
    "data-name": "\\u30D1\\u30B9 282",
    d: "M99.133,22.455c-2.691,2.255-4.746-1.171-6.445-1.484s-3.551-.019-3.551,3.092-2.968,2.9-2.968,0a8.441,8.441,0,0,1,8.443-8.439C100.613,15.624,101.823,20.2,99.133,22.455Z",
    transform: "translate(15.078 2.723)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_283",
    "data-name": "\\u30D1\\u30B9 283",
    d: "M94.715,13.405a11.045,11.045,0,1,0,11.052,11.046A11.048,11.048,0,0,0,94.715,13.405Z",
    transform: "translate(14.64 2.337)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_284",
    "data-name": "\\u30D1\\u30B9 284",
    d: "M114.291,19.637a5.549,5.549,0,0,1-4.746-2.653,15.757,15.757,0,0,0-25.912-1.494,5.363,5.363,0,0,1-4.228,2.081H75.9v6.151h4.492c-.042.47-.068.944-.068,1.424a15.755,15.755,0,0,0,31.47,1.118q.025-.359.033-.715a.973.973,0,0,1,.969-.955h1.5a1.135,1.135,0,0,0,1.135-1.134V20.772a1.134,1.134,0,0,0-1.135-1.134M96.074,36.193a11.045,11.045,0,1,1,11.052-11.046A11.048,11.048,0,0,1,96.074,36.193",
    transform: "translate(13.281 1.639)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_285",
    "data-name": "\\u30D1\\u30B9 285",
    d: "M114.291,19.637a5.549,5.549,0,0,1-4.746-2.653,15.757,15.757,0,0,0-25.912-1.494,5.363,5.363,0,0,1-4.228,2.081H75.9v6.151h4.492c-.042.47-.068.944-.068,1.424a15.755,15.755,0,0,0,31.47,1.118q.025-.359.033-.715a.973.973,0,0,1,.969-.955h1.5a1.135,1.135,0,0,0,1.135-1.134V20.772A1.134,1.134,0,0,0,114.291,19.637ZM96.074,36.193a11.045,11.045,0,1,1,11.052-11.046A11.048,11.048,0,0,1,96.074,36.193Z",
    transform: "translate(13.281 1.639)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_286",
    "data-name": "\\u30D1\\u30B9 286",
    d: "M73.315,17.572a5.306,5.306,0,0,1-4.2-2.047,15.741,15.741,0,0,0-25.9,1.414,5.545,5.545,0,0,1-4.7,2.7h-.094a1.135,1.135,0,0,0-1.135,1.134v2.689A1.136,1.136,0,0,0,38.423,24.6h1.513a.965.965,0,0,1,.967.938,15.751,15.751,0,0,0,31.5-.386c0-.48-.026-.955-.067-1.424h3.222a4.33,4.33,0,0,0,0-6.151ZM56.647,36.193A11.045,11.045,0,1,1,67.7,25.147,11.048,11.048,0,0,1,56.647,36.193",
    transform: "translate(6.525 1.639)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_287",
    "data-name": "\\u30D1\\u30B9 287",
    d: "M73.315,17.572a5.306,5.306,0,0,1-4.2-2.047,15.741,15.741,0,0,0-25.9,1.414,5.545,5.545,0,0,1-4.7,2.7h-.094a1.135,1.135,0,0,0-1.135,1.134v2.689A1.136,1.136,0,0,0,38.423,24.6h1.513a.965.965,0,0,1,.967.938,15.751,15.751,0,0,0,31.5-.386c0-.48-.026-.955-.067-1.424h3.222a4.33,4.33,0,0,0,0-6.151ZM56.647,36.193A11.045,11.045,0,1,1,67.7,25.147,11.048,11.048,0,0,1,56.647,36.193Z",
    transform: "translate(6.525 1.639)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_288",
    "data-name": "\\u30D1\\u30B9 288",
    d: "M100.795,27.563c-1.513.222-3.765-1.067-4.977-2.165a.936.936,0,0,0-1.312,1.334l1.449,1.544-6.1.794a.871.871,0,0,0-.75.986l.025.169a.87.87,0,0,0,.916.745l5.414-.342-6.065,1.077a.871.871,0,0,0-.7,1.053l0,.018a.87.87,0,0,0,.931.669l6.125-.59L90.032,34.04a.87.87,0,0,0-.651,1.124l0,.012a.871.871,0,0,0,.939.592l5.884-.759L92.4,36.134a.87.87,0,0,0,.443,1.683c1.913-.446,7.084-1.631,9.479-2Z",
    transform: "translate(15.517 4.385)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_289",
    "data-name": "\\u30D1\\u30B9 289",
    d: "M100.795,27.563c-1.513.222-3.765-1.067-4.977-2.165a.936.936,0,0,0-1.312,1.334l1.449,1.544-6.1.794a.871.871,0,0,0-.75.986l.025.169a.87.87,0,0,0,.916.745l5.414-.342-6.065,1.077a.871.871,0,0,0-.7,1.053l0,.018a.87.87,0,0,0,.931.669l6.125-.59L90.032,34.04a.87.87,0,0,0-.651,1.124l0,.012a.871.871,0,0,0,.939.592l5.884-.759L92.4,36.134a.87.87,0,0,0,.443,1.683c1.913-.446,7.084-1.631,9.479-2Z",
    transform: "translate(15.517 4.385)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_290",
    "data-name": "\\u30D1\\u30B9 290",
    d: "M121.6,17.826a22.589,22.589,0,0,1-7.7,7.381c-4.852,2.847-14.906,3.635-14.906,3.635l1.525,8.257c15.153-1.616,23.891-5.447,27.81-11.975",
    transform: "translate(17.322 3.107)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_291",
    "data-name": "\\u30D1\\u30B9 291",
    d: "M121.6,17.826a22.589,22.589,0,0,1-7.7,7.381c-4.852,2.847-14.906,3.635-14.906,3.635l1.525,8.257c15.153-1.616,23.891-5.447,27.81-11.975",
    transform: "translate(17.322 3.107)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_292",
    "data-name": "\\u30D1\\u30B9 292",
    d: "M41.439,26.091c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L46.28,26.8l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L52.2,32.568a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125a.87.87,0,0,1-.443,1.683c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(6.984 4.128)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_293",
    "data-name": "\\u30D1\\u30B9 293",
    d: "M41.439,26.091c1.513.222,3.765-1.067,4.977-2.165a.936.936,0,0,1,1.312,1.334L46.28,26.8l6.1.794a.871.871,0,0,1,.75.986l-.025.169a.87.87,0,0,1-.916.745l-5.414-.342,6.065,1.077a.871.871,0,0,1,.7,1.053l0,.018a.87.87,0,0,1-.931.669l-6.125-.59L52.2,32.568a.87.87,0,0,1,.651,1.124l0,.012a.871.871,0,0,1-.939.592l-5.884-.759,3.809,1.125a.87.87,0,0,1-.443,1.683c-1.913-.446-7.084-1.631-9.479-2Z",
    transform: "translate(6.984 4.128)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_294",
    "data-name": "\\u30D1\\u30B9 294",
    d: "M24.175,17.826a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C28.9,33.753,20.165,29.923,16.246,23.395",
    transform: "translate(2.843 3.107)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_295",
    "data-name": "\\u30D1\\u30B9 295",
    d: "M24.175,17.826a17.365,17.365,0,0,0,6.5,5.652c4.973,2.6,14.906,3.635,14.906,3.635l-1.524,8.257C28.9,33.753,20.165,29.923,16.246,23.395",
    transform: "translate(2.843 3.107)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_296",
    "data-name": "\\u30D1\\u30B9 296",
    d: "M74.5,19.436c0,1.7.713,3.076,1.594,3.076s1.593-1.377,1.593-3.076S76.978,16.36,76.1,16.36,74.5,17.737,74.5,19.436",
    transform: "translate(13.037 2.852)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_297",
    "data-name": "\\u30D1\\u30B9 297",
    d: "M74.5,19.436c0,1.7.713,3.076,1.594,3.076s1.593-1.377,1.593-3.076S76.978,16.36,76.1,16.36,74.5,17.737,74.5,19.436Z",
    transform: "translate(13.037 2.852)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_298",
    "data-name": "\\u30D1\\u30B9 298",
    d: "M106.316,40.383H119.3v1.389Z",
    transform: "translate(18.604 7.04)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_299",
    "data-name": "\\u30D1\\u30B9 299",
    d: "M106.316,40.383H119.3v1.389Z",
    transform: "translate(18.604 7.04)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  })), /*#__PURE__*/React.createElement("g", {
    id: "illust03",
    transform: "translate(-29 504)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_300",
    "data-name": "\\u30D1\\u30B9 300",
    d: "M3.729,82.494H111.276a3.454,3.454,0,0,0,3.445-3.443v-.333a3.455,3.455,0,0,0-3.445-3.443H3.729A3.456,3.456,0,0,0,.283,78.718v.333a3.455,3.455,0,0,0,3.446,3.443",
    transform: "translate(-0.003 -0.775)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_18",
    "data-name": "\\u9577\\u65B9\\u5F62 18",
    d: "M3.479,0H110.96a3.478,3.478,0,0,1,3.478,3.478V3.74a3.479,3.479,0,0,1-3.479,3.479H3.479A3.479,3.479,0,0,1,0,3.74V3.479A3.479,3.479,0,0,1,3.479,0Z",
    transform: "translate(0.281 74.501)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_301",
    "data-name": "\\u30D1\\u30B9 301",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792a3.046,3.046,0,0,1-3.047-3.044",
    transform: "translate(-0.335 -0.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_302",
    "data-name": "\\u30D1\\u30B9 302",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792A3.046,3.046,0,0,1,35.745,75.278Z",
    transform: "translate(-0.335 -0.718)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_303",
    "data-name": "\\u30D1\\u30B9 303",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414",
    transform: "translate(-0.404 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_304",
    "data-name": "\\u30D1\\u30B9 304",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414Z",
    transform: "translate(-0.404 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_305",
    "data-name": "\\u30D1\\u30B9 305",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_306",
    "data-name": "\\u30D1\\u30B9 306",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_307",
    "data-name": "\\u30D1\\u30B9 307",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_308",
    "data-name": "\\u30D1\\u30B9 308",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_309",
    "data-name": "\\u30D1\\u30B9 309",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_310",
    "data-name": "\\u30D1\\u30B9 310",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_311",
    "data-name": "\\u30D1\\u30B9 311",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3a6.706,6.706,0,0,0,6.388,4.659",
    transform: "translate(-0.486 -0.124)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_312",
    "data-name": "\\u30D1\\u30B9 312",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3A6.706,6.706,0,0,0,63.888,46.959Z",
    transform: "translate(-0.486 -0.124)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_313",
    "data-name": "\\u30D1\\u30B9 313",
    d: "M62.624,10.437a6.58,6.58,0,1,0-6.58,6.574,6.577,6.577,0,0,0,6.58-6.574",
    transform: "translate(-0.463 -0.039)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_13",
    "data-name": "\\u6955\\u5186\\u5F62 13",
    cx: 6.58,
    cy: 6.574,
    rx: 6.58,
    ry: 6.574,
    transform: "translate(49.001 3.824)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_10",
    "data-name": "\\u7DDA 10",
    x1: 1.511,
    y2: 0.043,
    transform: "translate(51.341 10.186)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_314",
    "data-name": "\\u30D1\\u30B9 314",
    d: "M50.076,8.6l-.161,0A1.67,1.67,0,0,0,48.3,10.316l0,.161A1.673,1.673,0,0,0,50.015,12.1l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,50.076,8.6Z",
    transform: "translate(-0.452 -0.088)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_315",
    "data-name": "\\u30D1\\u30B9 315",
    d: "M55.129,8.455l-.161,0a1.67,1.67,0,0,0-1.619,1.712l0,.161a1.673,1.673,0,0,0,1.715,1.618l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,55.129,8.455Z",
    transform: "translate(-0.5 -0.087)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_316",
    "data-name": "\\u30D1\\u30B9 316",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1M16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563m0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467",
    transform: "translate(-0.003 -0.003)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_317",
    "data-name": "\\u30D1\\u30B9 317",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1ZM16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563Zm0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467Z",
    transform: "translate(-0.003 -0.003)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_318",
    "data-name": "\\u30D1\\u30B9 318",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226",
    transform: "translate(-0.048 -0.496)",
    fill: "#b3dfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_319",
    "data-name": "\\u30D1\\u30B9 319",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226Z",
    transform: "translate(-0.048 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_320",
    "data-name": "\\u30D1\\u30B9 320",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917",
    transform: "translate(-0.048 -0.092)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_321",
    "data-name": "\\u30D1\\u30B9 321",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917Z",
    transform: "translate(-0.048 -0.092)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_322",
    "data-name": "\\u30D1\\u30B9 322",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52",
    transform: "translate(-0.063 -0.188)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_323",
    "data-name": "\\u30D1\\u30B9 323",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52Z",
    transform: "translate(-0.063 -0.188)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_324",
    "data-name": "\\u30D1\\u30B9 324",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686c0,6.172-4.715,7.416-7.037,4.649",
    transform: "translate(-0.134 -0.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_325",
    "data-name": "\\u30D1\\u30B9 325",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686C25.328,26.483,20.612,27.728,18.29,24.96Z",
    transform: "translate(-0.134 -0.119)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_326",
    "data-name": "\\u30D1\\u30B9 326",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_327",
    "data-name": "\\u30D1\\u30B9 327",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_328",
    "data-name": "\\u30D1\\u30B9 328",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115,9.067-.567,13.542,4.979,7.888-13.078",
    transform: "translate(-0.165 -0.192)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_329",
    "data-name": "\\u30D1\\u30B9 329",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115C31.1,33.693,35.575,39.239,29.921,21.182Z",
    transform: "translate(-0.165 -0.192)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_330",
    "data-name": "\\u30D1\\u30B9 330",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_331",
    "data-name": "\\u30D1\\u30B9 331",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_332",
    "data-name": "\\u30D1\\u30B9 332",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_333",
    "data-name": "\\u30D1\\u30B9 333",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_334",
    "data-name": "\\u30D1\\u30B9 334",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186a11.379,11.379,0,0,0-10.631-7.313",
    transform: "translate(-0.055 -0.496)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_335",
    "data-name": "\\u30D1\\u30B9 335",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186A11.379,11.379,0,0,0,16.556,48.226Z",
    transform: "translate(-0.055 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_336",
    "data-name": "\\u30D1\\u30B9 336",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_337",
    "data-name": "\\u30D1\\u30B9 337",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_338",
    "data-name": "\\u30D1\\u30B9 338",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_339",
    "data-name": "\\u30D1\\u30B9 339",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_340",
    "data-name": "\\u30D1\\u30B9 340",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_341",
    "data-name": "\\u30D1\\u30B9 341",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_342",
    "data-name": "\\u30D1\\u30B9 342",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634a6.526,6.526,0,0,0,.186-1.528",
    transform: "translate(-0.476 -0.039)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_343",
    "data-name": "\\u30D1\\u30B9 343",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634A6.526,6.526,0,0,0,62.637,10.437Z",
    transform: "translate(-0.476 -0.039)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_344",
    "data-name": "\\u30D1\\u30B9 344",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712c0,6.191-4.729,7.438-7.058,4.663",
    transform: "translate(-0.133 -0.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_345",
    "data-name": "\\u30D1\\u30B9 345",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712C25.229,67.82,20.5,69.067,18.17,66.292Z",
    transform: "translate(-0.133 -0.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_346",
    "data-name": "\\u30D1\\u30B9 346",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_347",
    "data-name": "\\u30D1\\u30B9 347",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  })), /*#__PURE__*/React.createElement("g", {
    id: "illust03-2",
    "data-name": "illust03",
    transform: "translate(290 504)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_348",
    "data-name": "\\u30D1\\u30B9 348",
    d: "M3.729,82.494H111.276a3.454,3.454,0,0,0,3.445-3.443v-.333a3.455,3.455,0,0,0-3.445-3.443H3.729A3.456,3.456,0,0,0,.283,78.718v.333a3.455,3.455,0,0,0,3.446,3.443",
    transform: "translate(-0.003 -0.775)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_20",
    "data-name": "\\u9577\\u65B9\\u5F62 20",
    d: "M3.479,0H110.96a3.478,3.478,0,0,1,3.478,3.478V3.74a3.479,3.479,0,0,1-3.479,3.479H3.479A3.479,3.479,0,0,1,0,3.74V3.479A3.479,3.479,0,0,1,3.479,0Z",
    transform: "translate(0.281 74.501)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_349",
    "data-name": "\\u30D1\\u30B9 349",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792a3.046,3.046,0,0,1-3.047-3.044",
    transform: "translate(-0.335 -0.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_350",
    "data-name": "\\u30D1\\u30B9 350",
    d: "M35.745,75.278h0a3.046,3.046,0,0,1,3.047-3.044h4.3V69.721h13.06v8.6H38.792A3.046,3.046,0,0,1,35.745,75.278Z",
    transform: "translate(-0.335 -0.718)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_351",
    "data-name": "\\u30D1\\u30B9 351",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414",
    transform: "translate(-0.404 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_352",
    "data-name": "\\u30D1\\u30B9 352",
    d: "M70.308,51.414H56.225V69.4H43.165V46.462a7.515,7.515,0,0,1,7.519-7.511h32.1A12.47,12.47,0,0,1,70.308,51.414Z",
    transform: "translate(-0.404 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_353",
    "data-name": "\\u30D1\\u30B9 353",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_354",
    "data-name": "\\u30D1\\u30B9 354",
    d: "M71.029,38.951l-14.7,28.512A7.232,7.232,0,0,0,62.77,78.006h28.9V66.536H71.287S86.255,45.912,86.255,38.951Z",
    transform: "translate(-0.52 -0.401)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_355",
    "data-name": "\\u30D1\\u30B9 355",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_356",
    "data-name": "\\u30D1\\u30B9 356",
    d: "M92.016,78.256h17.368a3.072,3.072,0,0,0,.8-6.038c-4.328-1.15-7.7-5.3-9.731-7.722a3.465,3.465,0,0,0-6.116,2.227v.063H92.016Z",
    transform: "translate(-0.862 -0.651)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_357",
    "data-name": "\\u30D1\\u30B9 357",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_358",
    "data-name": "\\u30D1\\u30B9 358",
    d: "M62.408,47.132l3.956,1.083.461-.895Z",
    transform: "translate(-0.584 -0.485)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_359",
    "data-name": "\\u30D1\\u30B9 359",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3a6.706,6.706,0,0,0,6.388,4.659",
    transform: "translate(-0.486 -0.124)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_360",
    "data-name": "\\u30D1\\u30B9 360",
    d: "M63.888,46.959H98.025a5.35,5.35,0,0,0,5.352-5.347v-.134a5.381,5.381,0,0,0-4.652-5.3,15.992,15.992,0,0,1-11.089-6.282c-4.77-5.716-10-3.634-13.646-9.656-.73-1.206-1.39-2.258-1.979-3.167A10.945,10.945,0,0,0,52.39,26.338L57.5,42.3A6.706,6.706,0,0,0,63.888,46.959Z",
    transform: "translate(-0.486 -0.124)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_361",
    "data-name": "\\u30D1\\u30B9 361",
    d: "M62.624,10.437a6.58,6.58,0,1,0-6.58,6.574,6.577,6.577,0,0,0,6.58-6.574",
    transform: "translate(-0.463 -0.039)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_14",
    "data-name": "\\u6955\\u5186\\u5F62 14",
    cx: 6.58,
    cy: 6.574,
    rx: 6.58,
    ry: 6.574,
    transform: "translate(49.001 3.824)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_11",
    "data-name": "\\u7DDA 11",
    x1: 1.511,
    y2: 0.043,
    transform: "translate(51.341 10.186)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_362",
    "data-name": "\\u30D1\\u30B9 362",
    d: "M50.076,8.6l-.161,0A1.67,1.67,0,0,0,48.3,10.316l0,.161A1.673,1.673,0,0,0,50.015,12.1l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,50.076,8.6Z",
    transform: "translate(-0.452 -0.088)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_363",
    "data-name": "\\u30D1\\u30B9 363",
    d: "M55.129,8.455l-.161,0a1.67,1.67,0,0,0-1.619,1.712l0,.161a1.673,1.673,0,0,0,1.715,1.618l.16,0a1.671,1.671,0,0,0,1.62-1.713l0-.16A1.673,1.673,0,0,0,55.129,8.455Z",
    transform: "translate(-0.5 -0.087)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_364",
    "data-name": "\\u30D1\\u30B9 364",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1M16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563m0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467",
    transform: "translate(-0.003 -0.003)",
    fill: "#393737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_365",
    "data-name": "\\u30D1\\u30B9 365",
    d: "M32.722,59.1a16.168,16.168,0,0,0-6.271-12.8,5.509,5.509,0,0,1-2.145-4.348V37.341a5.459,5.459,0,0,1,2.109-4.322A16.177,16.177,0,0,0,24.96,6.384a5.7,5.7,0,0,1-2.78-4.836v-.1A1.168,1.168,0,0,0,21.011.284H18.24a1.168,1.168,0,0,0-1.168,1.167V3.006a.994.994,0,0,1-.967,1,16.2,16.2,0,0,0,.4,32.4c.5,0,.984-.026,1.468-.069v6.635C17.486,42.921,17,42.9,16.5,42.9a16.2,16.2,0,0,0-1.151,32.368q.37.025.737.034a1,1,0,0,1,.984,1v1.542a1.168,1.168,0,0,0,1.168,1.168h2.771a1.169,1.169,0,0,0,1.169-1.168,5.707,5.707,0,0,1,2.731-4.882A16.186,16.186,0,0,0,32.722,59.1ZM16.5,31.563A11.367,11.367,0,1,1,27.881,20.195,11.373,11.373,0,0,1,16.5,31.563Zm0,38.9A11.367,11.367,0,1,1,27.881,59.1,11.373,11.373,0,0,1,16.5,70.467Z",
    transform: "translate(-0.003 -0.003)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_366",
    "data-name": "\\u30D1\\u30B9 366",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226",
    transform: "translate(-0.048 -0.496)",
    fill: "#b3dfef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_367",
    "data-name": "\\u30D1\\u30B9 367",
    d: "M16.548,48.226A11.367,11.367,0,1,0,27.927,59.594,11.373,11.373,0,0,0,16.548,48.226Z",
    transform: "translate(-0.048 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_368",
    "data-name": "\\u30D1\\u30B9 368",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917",
    transform: "translate(-0.048 -0.092)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_369",
    "data-name": "\\u30D1\\u30B9 369",
    d: "M16.548,8.917A11.367,11.367,0,1,0,27.927,20.285,11.373,11.373,0,0,0,16.548,8.917Z",
    transform: "translate(-0.048 -0.092)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_370",
    "data-name": "\\u30D1\\u30B9 370",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52",
    transform: "translate(-0.063 -0.188)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_371",
    "data-name": "\\u30D1\\u30B9 371",
    d: "M27.869,21.659c-7.725-5.034-15.381-5.047-21.091,4.52a11.38,11.38,0,0,0,21.091-4.52Z",
    transform: "translate(-0.063 -0.188)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_372",
    "data-name": "\\u30D1\\u30B9 372",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686c0,6.172-4.715,7.416-7.037,4.649",
    transform: "translate(-0.134 -0.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_373",
    "data-name": "\\u30D1\\u30B9 373",
    d: "M18.29,24.96c-2.322-2.767,1.206-4.881,1.529-6.629s.02-3.652-3.185-3.652-2.989-3.053,0-3.053a8.69,8.69,0,0,1,8.694,8.686C25.328,26.483,20.612,27.728,18.29,24.96Z",
    transform: "translate(-0.134 -0.119)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_374",
    "data-name": "\\u30D1\\u30B9 374",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_375",
    "data-name": "\\u30D1\\u30B9 375",
    d: "M65.724,27.045S58.1,35.274,57.39,36.112a7.6,7.6,0,0,1-1.467,1.331L54.9,34.236Z",
    transform: "translate(-0.514 -0.278)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_376",
    "data-name": "\\u30D1\\u30B9 376",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115,9.067-.567,13.542,4.979,7.888-13.078",
    transform: "translate(-0.165 -0.192)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_377",
    "data-name": "\\u30D1\\u30B9 377",
    d: "M29.921,21.182c-1.323-4.223-7.631-2.8-6.477,1.749a5.911,5.911,0,0,1-3.593,7.214c-3.8,1.558-2.427,4.4,2.181,4.115C31.1,33.693,35.575,39.239,29.921,21.182Z",
    transform: "translate(-0.165 -0.192)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_378",
    "data-name": "\\u30D1\\u30B9 378",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_379",
    "data-name": "\\u30D1\\u30B9 379",
    d: "M34.269,23.571C32.746,23.3,31,21.333,30.2,19.89a.947.947,0,0,0-1.689.855l.89,1.948L23.29,21.487a.88.88,0,0,0-1.037.7l-.031.169a.879.879,0,0,0,.638,1.009l5.3,1.419L22,23.866a.88.88,0,0,0-1.007.785l0,.018a.88.88,0,0,0,.678.942l6.064,1.41-5.874-.713a.881.881,0,0,0-.988.868v.012a.881.881,0,0,0,.709.87l5.887,1.171-4.016-.15a.88.88,0,0,0-.118,1.756c1.977.19,7.32.721,9.733,1.143Z",
    transform: "translate(-0.195 -0.199)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_380",
    "data-name": "\\u30D1\\u30B9 380",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_381",
    "data-name": "\\u30D1\\u30B9 381",
    d: "M58.453,19.038l-7.347,7.541L34.385,23.566l-1.2,8.407,18.067,3.487a7.411,7.411,0,0,0,6.2-1.632l8.068-6.866",
    transform: "translate(-0.311 -0.196)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_382",
    "data-name": "\\u30D1\\u30B9 382",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186a11.379,11.379,0,0,0-10.631-7.313",
    transform: "translate(-0.055 -0.496)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_383",
    "data-name": "\\u30D1\\u30B9 383",
    d: "M16.556,48.226A11.379,11.379,0,0,0,5.925,55.539H27.186A11.379,11.379,0,0,0,16.556,48.226Z",
    transform: "translate(-0.055 -0.496)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_384",
    "data-name": "\\u30D1\\u30B9 384",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "#bdbebf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_385",
    "data-name": "\\u30D1\\u30B9 385",
    d: "M5.918,55.615a11.378,11.378,0,1,0,21.261,0Z",
    transform: "translate(-0.048 -0.572)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_386",
    "data-name": "\\u30D1\\u30B9 386",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_387",
    "data-name": "\\u30D1\\u30B9 387",
    d: "M92.016,66.823v11.47H96.21a3.1,3.1,0,0,1-3.077-2.707Z",
    transform: "translate(-0.862 -0.688)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_388",
    "data-name": "\\u30D1\\u30B9 388",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_389",
    "data-name": "\\u30D1\\u30B9 389",
    d: "M56.339,51.544c-2.041,0,0,2.818,0,5.4Z",
    transform: "translate(-0.519 -0.53)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_390",
    "data-name": "\\u30D1\\u30B9 390",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634a6.526,6.526,0,0,0,.186-1.528",
    transform: "translate(-0.476 -0.039)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_391",
    "data-name": "\\u30D1\\u30B9 391",
    d: "M62.637,10.437A6.577,6.577,0,0,0,50.882,6.385C52.2,8.031,56.4,8.676,58.3,8.331c.442,3.344,2.735,3.553,4.151,3.634A6.526,6.526,0,0,0,62.637,10.437Z",
    transform: "translate(-0.476 -0.039)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_392",
    "data-name": "\\u30D1\\u30B9 392",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712c0,6.191-4.729,7.438-7.058,4.663",
    transform: "translate(-0.133 -0.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_393",
    "data-name": "\\u30D1\\u30B9 393",
    d: "M18.17,66.292c-2.33-2.775,1.209-4.9,1.533-6.65s.02-3.663-3.194-3.663-3-3.062,0-3.062a8.716,8.716,0,0,1,8.72,8.712C25.229,67.82,20.5,69.067,18.17,66.292Z",
    transform: "translate(-0.133 -0.545)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_394",
    "data-name": "\\u30D1\\u30B9 394",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "#876658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_395",
    "data-name": "\\u30D1\\u30B9 395",
    d: "M51.592,11.228l-.411.934a.514.514,0,0,0,.471.721h.907",
    transform: "translate(-0.479 -0.115)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImage);
export default __webpack_public_path__ + "static/media/bg-image.1efc8c76d520a653525507480abc76d9.svg";
export { ForwardRef as ReactComponent };